export default {
  "formioId": "NewRetailerRequest",
}